import nz from '@angular/common/locales/en-NZ';
import { registerLocaleData } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule, Injector, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '@env/environment';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsStoragePluginModule, StorageOption } from '@ngxs/storage-plugin';
import { NgxsModule } from '@ngxs/store';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppLoadModule } from './modules/app-load/app-load.module';
import { CoreModule } from './modules/core/core.module';
import { CanDeactivateGuard } from './modules/core/services/can-deactivate.guard';
import { ConfirmService } from './modules/core/services/confirm.service';
import { DialogService } from './modules/core/services/dialog.service';
import { AuthState } from './modules/core/state/auth.state';
import { ErrorModule } from './modules/error/error.module';
import { SharedModule } from './modules/shared/shared.module';
import { AppInjector } from './app-injector.service';
import { FilterState } from './modules/core/state/filter.state';
import { FeatureFlagService } from './modules/app-load/services/feature-flag.service';

registerLocaleData(nz, 'NZ');

export function HttpLoaderFactory(http: HttpClient) {
  return environment.production
    ? new TranslateHttpLoader(http, '/iq/assets/i18n/')
    : new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ErrorModule,
    AppRoutingModule,
    HttpClientModule,
    AppLoadModule,
    CoreModule.forRoot(),
    NgxsModule.forRoot([AuthState, FilterState], {
      developmentMode: !environment.production
    }),
    NgxsStoragePluginModule.forRoot({
      storage: StorageOption.SessionStorage,
      key: [
        'auth.user',
        'seller.purchaseConfig',
        'purchase.currentPurchase',
        'filter'
      ]
    }),
    // NgxsReduxDevtoolsPluginModule.forRoot({ disabled: environment.production }),
    environment.production ? [] : NgxsReduxDevtoolsPluginModule.forRoot(),

    environment.production ? [] : NgxsLoggerPluginModule.forRoot(),
    // NgxsLoggerPluginModule.forRoot({ disabled: environment.production }),
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'en-NZ' },
    DialogService,
    ConfirmService,
    CanDeactivateGuard,
    FeatureFlagService
    // ,
    // { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(injector: Injector) {
    AppInjector.setInjector(injector);
  }
}
